// extracted by mini-css-extract-plugin
export default {"root":"MultiLineColumn_root__UkM2G","name":"MultiLineColumn_name__6h6kh","no":"MultiLineColumn_no__5SFzk"};